
export const FASTAPI_HOST = process.env.REACT_APP_FASTAPI_HOST; // for CRA/Vite

// Keep account deletion hidden unless it is explicitly enabled for a build.
// For the future Apple iOS build, set REACT_APP_IS_MOBILE_APP=true.
export const IS_MOBILE_APP = process.env.REACT_APP_IS_MOBILE_APP === 'true';

// Free Talk remains available during development while it is temporarily
// hidden from production builds.
export const FREE_TALK_ENABLED = process.env.NODE_ENV !== 'production';

// App Store Connect product identifiers used by the iOS IAP purchase page.
// The defaults match the corresponding backend plan IDs and can be overridden
// per build without changing application code.
export const IOS_IAP_PRODUCT_IDS = {
  basic: process.env.REACT_APP_IOS_IAP_BASIC_MONTHLY_PRODUCT_ID || 'basic',
  basic_annual: process.env.REACT_APP_IOS_IAP_BASIC_ANNUAL_PRODUCT_ID || 'basic_annual',
  premium: process.env.REACT_APP_IOS_IAP_PREMIUM_MONTHLY_PRODUCT_ID || 'premium',
  premium_annual: process.env.REACT_APP_IOS_IAP_PREMIUM_ANNUAL_PRODUCT_ID || 'premium_annual',
};
